import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import { proofStats, insideScreenshots } from '../data/sections';
import { INSIDE_IMAGES } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ProofSection() {
  const featured = insideScreenshots.slice(0, 4);
  return <section className="bg-mp-dark py-20 md:py-28" data-id="element-325" data-mp="3e1lep8cjxo8t">
      <Container data-id="element-326" data-mp="3e0a870rq22e0">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-327" data-mp="3dzs7nry1120a">
          <SectionTag tone="white" data-id="element-328" data-mp="3is1u2xzxnjxt">No promesas. Contenido.</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-329" data-mp="3nr4xke09li3o">
            Un sistema que puedes ver antes de comprar.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4 md:grid-cols-7" data-id="element-330" data-mp="1jyadlt4j390">
          {proofStats.map((stat, i) => <motion.div key={stat.copy} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.35,
          ease: easeOut,
          delay: i % 4 * 0.05
        }} className="rounded-xl border border-mp-border bg-mp-card p-4 text-center" data-id="element-331" data-mp="15ojehyji9g73" data-mpi={i}>
              <p className="font-heading text-2xl text-mp-lime sm:text-3xl" data-id="element-332" data-mp="1oe99aln9q1z0">{stat.title}</p>
              <p className="mt-1 text-[11px] uppercase tracking-wide text-mp-gray sm:text-xs" data-id="element-333" data-mp="1jeel4puvnqhn">{stat.copy}</p>
            </motion.div>)}
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4" data-id="element-334" data-mp="1em3ktlw862ok">
          {featured.map(label => <PlaceholderMockup key={label} label={label} aspect="aspect-[4/3]" src={INSIDE_IMAGES[label]} alt={`Vista interior de Maestro en Pista — ${label}`} width={800} height={600} data-id="element-335" data-mp="274h6yo87807t" />)}
        </div>
      </Container>
    </section>;
}